/**
 * Builds an exact-match filter for looking a user up by email.
 *
 * Emails are canonicalized to lowercase on every write (see {@link normalizeEmail}), so the stored
 * value is always the normalized form. Matching the normalized query email for equality is
 * therefore equivalent to the previous case-insensitive `$regex` — but, unlike a regex, an equality
 * predicate can use the `{ email: 1 }` index. Callers do not need to normalize beforehand; this
 * does it for them.
 */
export function normalizedEmailFilter(email: string): { email: string } {
  return { email: normalizeEmail(email) };
}

/**
 * Canonical form in which emails are persisted: trimmed and lowercased.
 * Use this everywhere an email is written to the database so that stored
 * values stay consistent and uniqueness checks are reliable.
 */
export function normalizeEmail(email: string): string {
  return email.trim().toLowerCase();
}
